angular.module('core')
  .service('progressApi',['$http', 'transformResponse', 'cancelableResourceFactory', 'cancelableResourceManager', '$state', 'standardsApi', 'moment', '$q', function($http, $transformResponse, $cancelableResourceFactory, $cancelableResourceManager, $state, dblStandardsApi, $moment, $q){

      var self = this;

      var Progress = $cancelableResourceFactory.createCacheableResource(null, '/r/districts/:district_id/students/:student_id/goal_', {
          district_id : '@district_id',
          student_id: '@user_id'
      }, {
          getSummary: {
              url: '/r/districts/:district_id/students/:student_id/goal_summary',
              method: 'GET'
          },
          getReport: {
              url: '/r/districts/:district_id/students/:student_id/goal_report',
              method: 'GET'
          }
      });

      self.getStudentDistrictID = function () {
        return $state.params.studentDistrictId ? $state.params.studentDistrictId : $state.params.districtId;
      };

      /**************************************************************/
      /*                          Api                               */
      /**************************************************************/

      self.getGoalSummaryForStudent = function(focus_type, focus_id, callback) {
          var params = {
              district_id: self.getStudentDistrictID(),
              student_id: $state.params.studentId,
              focus_type: focus_type,
              focus_id: focus_id,
              to_date: $moment().utc().format("YYYYMMDD")
          };

          var promises = Progress.getSummary(params);
          promises.$promise.then(callback);
          return promises;
      };

      self.getStudentGoalReport = function(student_id, from_date, to_date, focus_id, focus_type, callback) {
          var student_district_id = $state.params.studentDistrictId ? $state.params.studentDistrictId : $state.params.districtId;
          var params = {
              district_id: self.getStudentDistrictID(),
              student_id: student_id,
              from_date: from_date,
              to_date: to_date,
              focus_type: focus_type,
              focus_id: focus_id
          };

          var promises = Progress.getReport(params);
          promises.$promise.then(callback);
          return promises;
      };

      self.getStandardData = function(focusType, focusId) {
          var params = {
              focus_type: focusType,
              focus_id: focusId
          };

          var resource = dblStandardsApi.StandardData.get(params);
          $cancelableResourceManager.addAndRemoveOnFinish(resource);

          return resource.$promise;
      };

      self.getGoalStandardProgressForStudent = function(districtId, studentId, focusType, focusId, toDate) {
          return self.getStandardData(focusType, focusId).then(function(data) {
              return self.getGoalStandardProgressForStudentGivenStandardData(districtId, studentId, data.data, toDate);
          });
      };

      self.getGoalStandardProgressForStudentGivenStandardData = function(districtId, studentId, standardData, toDate) {
          if(standardData === null) {
              return $q.reject('Standard data is null');
          }
          var params = {};
          params.districtId = districtId;
          params.studentId = studentId;
          params.gradeId = standardData.mgd_level_id;
          params.domainId = standardData.mgd_concept_id;
          params.clusterId = standardData.mgd_cluster_id;

          // the struggling status will be calculated based on the assignment.end_date - 30 days to the assignment.end_date
          // (so the last 30 days of the assignment)... If the assignment is active - it will be calculated based on the last 30 days
          params.td = $moment() < $moment(toDate,'YYYYMMDD') ? $moment().format('YYYYMMDD') : toDate;

          var resource = dblStandardsApi.StudentStandards.get(params);
          $cancelableResourceManager.addAndRemoveOnFinish(resource);

          return resource.$promise;
      };

}]);
